/**
 * @file 为组件添加固定的className的HOC
 * @author chenbo09
 */

import React from 'react';
import classNames from 'classnames';

const getDisplayName = Component => {
    if (typeof Component === 'string') {
        return Component;
    }

    if (!Component) {
        return undefined;
    }

    return Component.displayName || Component.name || 'Component';
};
const wrapDisplayName = (BaseComponent, hocName) =>
    `${hocName}(${getDisplayName(BaseComponent)})`;

export default (extraClassName: string) => (BaseComponent: React.ComponentType<any>) => {
    const WrappedComponent = ({className = '', ...props}) => (
        <BaseComponent
            {...props}
            className={classNames(className, extraClassName)}
        />
    );

    WrappedComponent.displayName = wrapDisplayName(
        BaseComponent,
        'withClassName'
    );
    return WrappedComponent;
};
